import React, { ComponentProps } from 'react';

import PropTypes from 'prop-types';

import Button from '@adsk/alloy-react-button';
import Footer, { ClearButton } from '@adsk/alloy-react-footer';
import { useDeprecate } from '@adsk/alloy-react-helpers';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

import { GenericItem } from '../types';

export type ClearableFooterProps<TItem extends GenericItem> =
  StylableComponent<HTMLDivElement> & {
    setSelectedItems: (items: TItem[]) => void;
    clearButtonProps?: ComponentProps<typeof Button>;
  };

/**
 * @deprecated use Footer from "@adsk/alloy-react-footer"
 */
const ClearableFooter = <TItem extends GenericItem>({
  style,
  children,
  setSelectedItems,
  clearButtonProps,
  ...props
}: ClearableFooterProps<TItem>) => {
  useDeprecate(
    true,
    'Dropdown',
    'ClearableFooter',
    'Footer from @adsk/alloy-react-footer',
  );

  return (
    <Footer {...props}>
      {children}
      <ClearButton onClick={() => setSelectedItems([])} {...clearButtonProps} />
    </Footer>
  );
};

ClearableFooter.displayName = 'ClearableFooter';

ClearableFooter.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Additional content, displayed to the left of the Clear button */
  children: PropTypes.node,
  /** Function used to set selected items to an empty array.  This is returned from the dropdown hook */
  setSelectedItems: PropTypes.func.isRequired,
  /** Optional props to set on the Clear button */
  clearButtonProps: PropTypes.object,
};

export default ClearableFooter;
